import * as React from 'react'

interface UseComboboxFreezeResult<T> {
  isUserTyped: boolean
  isJustSelected: boolean
  pickItems: (liveItems: T[]) => T[]
  onTyped: (next: string) => void
  freeze: (selectedLabel: string, items: T[]) => void
}

export function useComboboxFreeze<T>(
  value: string,
): UseComboboxFreezeResult<T> {
  const lastTypedRef = React.useRef<string | null>(null)
  const [lastSelected, setLastSelected] = React.useState<string | null>(null)
  const [frozenItems, setFrozenItems] = React.useState<T[] | null>(null)

  const isUserTyped =
    lastTypedRef.current !== null && lastTypedRef.current === value
  const isJustSelected = lastSelected !== null && value === lastSelected

  const pickItems = (liveItems: T[]) =>
    isJustSelected && frozenItems !== null ? frozenItems : liveItems

  const onTyped = (next: string) => {
    lastTypedRef.current = next
    if (next !== lastSelected) {
      setLastSelected(null)
      setFrozenItems(null)
    }
  }

  const freeze = (selectedLabel: string, items: T[]) => {
    setFrozenItems(items)
    setLastSelected(selectedLabel)
  }

  return { isUserTyped, isJustSelected, pickItems, onTyped, freeze }
}
